<template>
  <div class="VideoPage" :class="classes">
    <Page>
      <video class="VideoPage__video" playsinline muted autoplay ref="video">
        <!-- using multiple ifs here because HTML video src doesn't work with dynamic value -->
        <source
          v-if="theme === 'orchard'"
          src="../assets/video/orchard.mp4"
          type="video/mp4"
        />
        <source
          v-if="theme === 'smoke'"
          src="../assets/video/smoke.mp4"
          type="video/mp4"
        />
        <source
          v-if="theme === 'chard'"
          src="../assets/video/chard.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <div class="VideoPage__controls">
        <img
          class="VideoPage__logo"
          alt="Logo"
          :src="require(`../assets/video-${theme}-logo.svg`)"
        />
        <div class="VideoPage__progress" ref="progress">
          <div
            class="VideoPage__progress__bar"
            ref="progressBar"
            style="width:0%"
          ></div>
        </div>
        <button @click="play" class="VideoPage__replay">
          <transition name="u-fade-in">
            <div v-if="show.cta">
              <img
                v-if="playing"
                alt="Replay"
                :src="require(`../assets/replay-${theme}.svg`)"
              />
              <img
                v-else
                alt="Replay"
                :src="require(`../assets/play-${theme}.svg`)"
              />
            </div>
          </transition>
        </button>
        <div class="VideoPage__skip">
          <base-button :theme="theme" wide @click="onNext">Next</base-button>
        </div>
      </div>
    </Page>
  </div>
</template>

<script>
import Page from '../components/Page'
import BaseButton from '../components/BaseButton'
import { audioMixin } from '../mixins/audioMixin'
export default {
  components: { BaseButton, Page },
  mixins: [audioMixin],
  data() {
    return {
      lsState: {
        orchard: false,
        smoke: false,
        chard: false
      },
      videoElement: null,
      updateBar: null,
      ended: false,
      playing: false,
      theme: 'orchard',
      videos: {
        orchard: '../assets/video/33635608-preview.mp4',
        smoke: '../assets/video/33635608-preview.mp4',
        chard: '../assets/video/33635608-preview.mp4'
      },
      show: {
        cta: false
      }
    }
  },
  computed: {
    classes() {
      return {
        [`VideoPage--theme--${this.theme}`]: this.theme
      }
    }
  },
  mounted() {
    this.lsState = {
      ...JSON.parse(sessionStorage.getItem('glenlivet_state'))
    }
    // Set theme. x3 possible variations.
    if (this.$route.query.theme) {
      this.theme = this.$route.query.theme
    }
    this.videoElement = this.$refs.video
    this.videoListeners()

    setTimeout(() => {
      this.show.cta = true
    }, 200)

    this.$log.info('lsState[theme]', this.lsState[this.theme])
  },
  beforeDestroy() {
    window.clearInterval(this.updateBar)
  },
  methods: {
    onNext() {
      this.$router.push({ path: 'flavour', query: { theme: this.theme } })
      this.playSound(`flavour-${this.theme}`)
    },
    videoListeners() {
      if (this.videoElement !== null) {
        // Possibility of no video loaded in DOM
        this.videoElement.onplay = () => {
          this.playing = true
          this.updateBar = setInterval(this.updateProgressBar, 50)
          this.playSound(`video-${this.theme}`)
        }
        this.videoElement.onended = () => {
          window.clearInterval(this.updateBar)
          this.ended = true
          //this.$log.info('Video ended.')
          // Display next button

          /*
            had to disable auto go to next route because need to trigger audio
            this.$router.push({
              path: 'flavour',
              query: {
                theme: this.theme,
              }
            } */
        }
      }
    },
    updateProgressBar() {
      const barSize = this.$refs.progress && this.$refs.progress.clientWidth
      if (!barSize) {
        return
      }
      //this.$log.info('barSize', barSize)
      //this.$log.info('updateProgressBar called.')
      if (!this.videoElement.ended) {
        const size = parseInt(
          (this.videoElement.currentTime * barSize) / this.videoElement.duration
        )
        this.$refs.progressBar.style.width = size + 'px'
      } else {
        //this.$refs.progressBar.style.width= '0px';
        window.clearInterval(this.updateBar)
      }
    },
    play() {
      window.clearInterval(this.updateBar)
      this.playSound(`video-${this.theme}`)
      this.videoElement.pause()
      this.videoElement.currentTime = '0'
      this.videoElement.play()
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables.scss';
@import '../scss/mixins.scss';

.VideoPage {
  background-color: #000;
  background-size: 100%;
  overflow: hidden;
  .Page {
    position: relative;
    overflow: hidden;
  }
  &__logo {
    position: absolute;
    left: 50%;
    top: 33px;
    margin-left: -31px;
  }
  &__replay {
    background: transparent;
    border: 0;
    cursor: pointer;
    position: absolute;
    left: 20px;
    bottom: 23px;
    z-index: 1;
  }
  &__skip {
    position: absolute;
    right: 20px;
    bottom: 22px;
    z-index: 1;
  }
  &__progress {
    position: absolute;
    left: 20px;
    bottom: 96px;
    background-color: rgba(0, 0, 0, 0.5);
    height: 3px;
    width: calc(100% - 40px);
    border-radius: 16px !important;
    &__bar {
      background-image: $orchard-gradient;
      height: 100%;
      border-radius: 16px !important;
    }
  }
  &__video {
    position: absolute;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;
    width: 100%;
  }
  &__image {
    margin-bottom: 20px;
  }
  &__content {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    justify-content: flex-end;
    p {
      color: $light-font-color;
      text-align: center;
      margin: 0 auto 35px auto;
      max-width: 260px;
    }
    .BaseButton {
      margin-bottom: 42px;
    }
  }

  // Theme variations

  &--theme--smoke {
    .VideoPage__progress {
      .VideoPage__progress__bar {
        background-image: linear-gradient(
          10deg,
          #8789a9 0%,
          #a5b0e3 50%,
          #8789a9 100%
        );
      }
    }
  }
}
</style>
